import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 7a1 1 0 0 0-2 0v15a1 1 0 1 0 2 0v-6.5h11V22a1 1 0 1 0 2 0V7a1 1 0 1 0-2 0v6.5H6zM24 12.5a1 1 0 1 0 0 2h4.08l-2.4 3.427a1 1 0 0 0 .82 1.573 2.5 2.5 0 1 1-1.768 4.268 1 1 0 0 0-1.414 1.414 4.5 4.5 0 1 0 4.872-7.352l2.63-3.756A1 1 0 0 0 30 12.5z"
    />
  </svg>
);
const SvgIconTextHThree = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTextHThree);
export default Memo;
